import React from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useAsync } from 'react-use';
import { DashboardPage } from '../../ui/dashboard/DashboardPage';
import { Flex } from '../../ui/layout/Flex';
import { Typography } from '../../ui/typography/Typography';
import { useTranslation } from '../../utils/useTranslation';

export const ErrorPage = () => {
    const t = useTranslation();
    const navigate = useNavigate();

    const { loading } = useAsync(async () => {
        const response = await axios.get('/feed', {
            params: {
                amount: 1,
            },
        });

        if (!response.headers['Decline-Reason']) {
            navigate('/');
        }
    }, []);

    return (
        <DashboardPage>
            {!loading && (
                <Flex width="100%" height="100%" alignItems="start" justifyContent="center" px={4}>
                    <Typography variant="title1" weight="heavy">
                        {t('Не нашли рекомендаций в вашем регионе')}
                    </Typography>
                </Flex>
            )}
        </DashboardPage>
    );
};
